import React, { useRef } from "react";
import PropTypes from "prop-types";
import Preloader from "../UI/Preloader/Preloader";
// --- Import Styles
import "./Toggle.sass";

const Toggle = ({
  checked,
  onChange,
  isLoading,
  error,
  labelStart,
  labelEnd,
  ariaLabel,
  tooltip,
}) => {
  const checkboxId = useRef(Math.random() * 10000);
  const { text: tooltipText, Icon } = tooltip;

  return (
    <>
      <div className="toggle">
        {labelStart && (
          <>
            <p className="toggle__text toggle__text--start">{labelStart}</p>{" "}
            {tooltipText && (
              <span className="toggle-tooltip">
                <Icon className="toggle-tooltip__icon" />
                <span className="toggle-tooltip__text">{tooltipText}</span>
              </span>
            )}
          </>
        )}

        <div className="toggle-checkbox">
          <input
            id={checkboxId.current}
            type="checkbox"
            className="toggle-checkbox__input"
            checked={checked}
            onChange={onChange}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label
            aria-label={ariaLabel}
            htmlFor={checkboxId.current}
            className="toggle-checkbox__label"
          />
        </div>
        {labelEnd && (
          <>
            <p className="toggle__text toggle__text--end">{labelEnd}</p>{" "}
            {tooltipText && (
              <span className="toggle-tooltip">
                <Icon className="toggle-tooltip__icon" />
                <span className="toggle-tooltip__text">{tooltipText}</span>
              </span>
            )}
          </>
        )}
        {isLoading && (
          <Preloader width="15px" height="15px" className="toggle__loading" />
        )}
      </div>
      {error && <div className="toggle__error">{error}</div>}
    </>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  labelStart: PropTypes.string,
  labelEnd: PropTypes.string,
  ariaLabel: PropTypes.string,
  tooltip: PropTypes.shape({
    text: PropTypes.string,
    Icon: PropTypes.elementType,
  }),
};

Toggle.defaultProps = {
  labelStart: "",
  labelEnd: "",
  isLoading: false,
  error: "",
  ariaLabel: "Toggle",
  tooltip: { text: "", Icon: null },
};

export default Toggle;
